
import { Link } from "react-router-dom";
import {
  SidebarMenuSubButton,
  SidebarMenuSubItem as SidebarMenuSubItemBase,
} from "@/components/ui/sidebar";
import type { MenuItem } from "./menuItems";

interface SidebarMenuSubItemProps {
  item: MenuItem;
  showIcons: boolean;
  isActive: (href: string) => boolean;
  level?: number;
}

export function SidebarMenuSubItem({
  item,
  showIcons,
  isActive,
  level = 0
}: SidebarMenuSubItemProps) {
  const isItemActive = isActive(item.href);
  
  return (
    <SidebarMenuSubItemBase>
      <SidebarMenuSubButton 
        asChild 
        isActive={isItemActive}
        className={`
          group relative transition-all duration-200 
          py-2 px-3 mx-0 my-0.5 rounded-lg
          ${isItemActive 
            ? 'bg-primary/5 text-primary border-r-2 border-primary shadow-sm' 
            : 'hover:bg-accent/50 text-foreground/70 hover:text-foreground'
          }
        `}
      >
        <Link to={item.href} className="flex items-center gap-2.5 w-full min-w-0" dir="rtl">
          {showIcons && item.icon && (
            <div className={`
              relative flex items-center justify-center flex-shrink-0 transition-all duration-300
              w-7 h-7 rounded-md
              ${isItemActive 
                ? 'bg-primary/10 shadow-sm' 
                : 'bg-gradient-to-br ' + (item.color || 'from-muted-foreground/50 to-muted-foreground/30') + ' group-hover:shadow-sm'
              }
            `}>
              <item.icon className={`${isItemActive ? 'text-primary' : 'text-white'} w-3.5 h-3.5`} />
            </div>
          )}
          <span className={`
            font-medium text-xs flex-1 text-right truncate
            ${isItemActive ? 'text-primary font-semibold' : 'text-foreground/70 group-hover:text-foreground'}
          `}>
            {item.title}
          </span>
          {isItemActive && (
            <div className="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0"></div>
          )}
        </Link>
      </SidebarMenuSubButton>
    </SidebarMenuSubItemBase>
  );
}
